import { apiService } from './apiService';
import type { ApiResponse } from './adminApiService';

export interface EnhancedPersonalRegistrationData {
  // Product Information
  productId: number;
  productType: string;
  productName?: string;
  
  // Basic Information
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  gender: string;
  nationality: string;
  idNumber: string;
  idCountryOfIssue: string;
  idDateOfExpiry: string;
  socialInsuranceNumber: string;

  // Address and Employment
  address: {
    street: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
  employment: {
    employerName: string;
    jobTitle: string;
    monthlyIncome: string;
    duration: string;
  };

  // Documents
  documents: {
    passport: boolean;
    identityCard: boolean;
    utilityBill: boolean;
    bankReference: boolean;
    cv: boolean;
    trustDeed: boolean;
    boardMinutes: boolean;
    powerOfAttorney: boolean;
    other: boolean;
    otherSpecify?: string;
  };

  // Terms and Signature
  pep: boolean;
  sourceOfFunds: string;
  purposeOfAccount: string;
  signatureDataUrl?: string;
}

export type EnhancedPersonalRegistration = FormData;

export type EnhancedBusinessRegistration = FormData;

class RegistrationService {
  async submitEnhancedPersonalRegistration(formData: FormData): Promise<ApiResponse<any>> {
    // Log FormData contents before sending
    console.log('Service - FormData entries:');
    Array.from(formData.entries()).forEach(([key, value]) => {
      console.log(key, ':', typeof value === 'string' ? value.substring(0, 100) + '...' : 'File');
    });

    return apiService.request('/auth/register/personal/enhanced', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        // Don't set Content-Type, let the browser set it with the boundary
      }
    });
  }

  async submitEnhancedBusinessRegistration(formData: FormData): Promise<ApiResponse<any>> {
    // Log FormData contents before sending
    console.log('Service - FormData entries:');
    Array.from(formData.entries()).forEach(([key, value]) => {
      console.log(key, ':', typeof value === 'string' ? value.substring(0, 100) + '...' : 'File');
    });

    return apiService.request('/auth/register/business/enhanced', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      }
    });
  }

  async uploadEnhancedPersonalSummaryPdf(email: string, file: File): Promise<ApiResponse<any>> {
    const form = new FormData();
    form.append('email', email);
    form.append('file', file);
    return apiService.request('/auth/register/personal/enhanced/summary-pdf', {
      method: 'POST',
      body: form,
      headers: {
        Accept: 'application/json',
      }
    });
  }

  async uploadEnhancedBusinessSummaryPdf(email: string, file: File): Promise<ApiResponse<any>> {
    const form = new FormData();
    form.append('email', email);
    form.append('file', file);
    return apiService.request('/auth/register/business/enhanced/summary-pdf', {
      method: 'POST',
      body: form,
      headers: {
        Accept: 'application/json',
      }
    });
  }
}

export const registrationService = new RegistrationService();
